// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1rhjk520 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}
@media screen and (min-width: 769px) {
  ._1rhjk520 {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 20px;
  }
}
@media screen and (max-width: 768px) {
  ._1rhjk520 {
    margin-left: -16px;
    margin-right: -16px;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;AACA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":["._1rhjk520 {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n@media screen and (min-width: 769px) {\n  ._1rhjk520 {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 20px;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._1rhjk520 {\n    margin-left: -16px;\n    margin-right: -16px;\n    gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
